import * as Primitive from "@radix-ui/react-context-menu";
import type { ComponentProps } from "react";
import { cn } from "@/shared/lib/cn";

export const ContextMenu = Primitive.Root;
export const ContextMenuTrigger = Primitive.Trigger;

export function ContextMenuContent({
  className,
  ...props
}: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Content
        className={cn(
          "z-50 min-w-44 rounded-md border border-border bg-bg p-1 shadow-lg",
          className,
        )}
        {...props}
      />
    </Primitive.Portal>
  );
}

export function ContextMenuItem({ className, ...props }: ComponentProps<typeof Primitive.Item>) {
  return (
    <Primitive.Item
      className={cn(
        "flex cursor-default select-none items-center gap-2 rounded px-2 py-1.5 text-sm outline-none data-[highlighted]:bg-surface data-[disabled]:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export const ContextMenuSeparator = (props: ComponentProps<typeof Primitive.Separator>) => (
  <Primitive.Separator className="my-1 h-px bg-border" {...props} />
);
